import { render, staticRenderFns } from "./pos-side-nav.vue?vue&type=template&id=052db37e&"
import script from "./pos-side-nav.vue?vue&type=script&lang=js&"
export * from "./pos-side-nav.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports